import { _api } from '../../utils/apiAxios';

const state = {
  status: { loading: false },
  hasSearchResult: false,
  successModal: {
    show: false,
    isClosable: true,
    content: '',
    title: '',
  },
  errorModal: {
    show: false,
    isClosable: true,
    content: '',
    title: '',
  },
  loadings: [],
  vk_visible: false,
  vk_input: null,
  vk_input_value: null,
  eposVersion: null,
  vk_common_input: null,
  vk_common_input_value: null,
  vk_common_visible: null,
  showIdleModal: false,
  showSportsMenuModal: false,
};
const mutations = {
  initializing: state => {
    state.status = { loading: true };
  },
  setShowSportsMenuModal: (state, val) => {
    state.showSportsMenuModal = val;
  },
  setCountries: (state, arr) => {
    state.countries = arr;
  },
  setHasSearchResult: (state, data) => {
    state.hasSearchResult = data;
  },
  openSuccessModal: (state, { content, isClosable, title }) => {
    state.successModal = {
      show: true,
      content,
      title,
      isClosable,
    };
  },
  closeSuccessModal: state => {
    state.successModal = {
      show: false,
      content: '',
      title: '',
      isClosable: true,
    };
  },

  openErrorModal: (state, { content, isClosable, title }) => {
    state.errorModal = {
      show: true,
      content,
      title,
      isClosable,
    };
  },
  closeErrorModal: state => {
    state.errorModal = {
      show: false,
      content: '',
      title: '',
      isClosable: true,
    };
  },
  setLoading: (state, { httpUrl, isLoading }) => {
    const loadings = state.loadings;
    const index = loadings.indexOf(httpUrl);
    if (!isLoading) {
      state.loadings = [...loadings.slice(0, index), ...loadings.slice(index + 1)];
    } else {
      state.loadings = [...loadings, httpUrl];
    }
  },
  vk_show(state, e) {
    e.target.value = e.target.value.replace('$', '');
    state.vk_input = e.target;
    state.vk_visible = true;
  },
  vk_hide(state) {
    state.vk_input = null;
    state.vk_visible = false;
  },
  vk_update_value(state, input) {
    state.vk_input.type = 'text';
    state.vk_input.value = input;
    state.vk_input.dispatchEvent(new Event('input', { bubbles: true }));
    //state.vk_input.dispatchEvent(new Event('focus', { bubbles: true }));
  },
  vk_update_input_value(state, value) {
    state.vk_input_value = value;
  },
  setEposVersion(state, value) {
    state.eposVersion = value;
  },
  vk_common_show(state, { target, visible }) {
    state.vk_common_input = target;
    state.vk_common_visible = visible;
  },
  vk_common_update_value(state, input) {
    state.vk_input.value = input;
    state.vk_input.dispatchEvent(new Event('input', { bubbles: true }));
  },
  setShowIdleModal(state, value) {
    state.showIdleModal = value;
  },
};
const getters = {
  isLoading: state => url => {
    return state.loadings.includes(url);
  },
};
const actions = {
  getCountries: ({ commit }) => {
    commit('initializing');
    _api.get('/dictionary/allcountries').then(r => {
      if (r.data.IsSuccess) {
        commit('setCountries', r.data.Data);
      }
    });
  },
  getStates: ({ commit }, iso2) => {
    commit('initializing');
    return _api.get('/dictionary/states/' + iso2);
  },
  searchByTerm: ({ rootState }, term) => {
    return _api.post('/Navigation/Search', {
      Keyword: term,
      Language: rootState.settings.selectedLocale.code,
    });
  },
  setHasSearchResult: ({ commit }, data) => {
    commit('setHasSearchResult', data);
  },
};

export const helper = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
